// src/redux/reducers/cityReducer.js
import {
    FETCH_GETORGDINS_FAILURE,
    FETCH_GETORGDINS_REQUEST,
    FETCH_GETORGDINS_SUCCESS, 
    SET_SELECTED_GETORGDINS ,
  } from '../types'; 
  
  const initialState = {
    loading: false,
    getallorgsList: [],
    selectedgetallId: null, 
    error: null,
  };
  
  
  const getRegdInsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GETORGDINS_REQUEST:
        return { ...state, loading: true };
      case FETCH_GETORGDINS_SUCCESS:
        return { ...state, loading: false, getallorgsList: action.payload };
      case FETCH_GETORGDINS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_GETORGDINS:
        return { ...state, selectedgetallId: action.payload };
      default:
        return state;
    }
  };
  
  export default getRegdInsReducer;



  